<template>
  <div class="game">
    <div
      class="game_top_content"
      :class="{ 'is-login': isLogin }"
      id="main-container"
      :style="{ overflowY: isNoScroll ? 'hidden' : 'auto' }"
      v-touchmove
    >
      <div
        class="gameback"
        :class="[
          {
            'no-banner skeleton-shimmer':
              (!activityBanner && !gameConfig.banner_icon) || !activityBannerLoaded,
          },
          isMobile ? 'mobile' : 'pc',
        ]"
      >
        <img
          v-if="gameConfig.banner_icon || activityBanner"
          :src="gameConfig.banner_icon || activityBanner"
          @load="activityBannerLoaded = true"
          @error="activityBannerLoaded = true"
          :alt="bannerAlt"
        />
        <GameTaskRewards
          ref="gameTaskRewards"
          v-if="showTaskRewardsChest"
          :game-info="gameinfo"
          :game-id="gameid"
          @clear-rewards-red-dot="clearRewardsRedDot"
        />
      </div>
      <HomeStickyFat v-if="gameid === '20195' && isLogin" />
      <HomeUserInfo v-if="gameid !== '20195'" />
      <div class="common-wrapper" v-if="game_name !== 'home'">
        <!-- 公告 -->
        <Announcement :language_code="$i18n.locale" :currency="conutry.money"></Announcement>
      </div>

      <!-- 礼包列表 -->
      <GiftSection @goodItemClick="(item) => selpackage(item, true)" />

      <!-- 充值说明 -->
      <ShopTips :showDesc="editis" class="common-wrapper" />

      <Foot />
    </div>

    <!-- 支付结果 -->
    <PayResult
      v-if="maskstyle != '' && !invoiceis && list.length"
      :maskstyle="maskstyle"
      :payinfo="payinfo"
      :orderinfo="orderinfo"
      :paysty="paysty"
      :moneyUnit="moneyUnit"
      :ru_psp_payment_type="ru_psp_payment_type"
      :emailSended="emailSended"
      @close="maskstyle = ''"
      @goShopping="goShopping"
      @payAgain="payAgain"
      @sendToEmail="openInvoice"
      @refresh="getPackageInfo"
    />

    <!-- 获取凭据 -->
    <Dialog
      class="invoice-dialog"
      :visible.sync="invoiceis"
      :title="$t('game.getInvoiceTitle')"
      @touchmove.native.prevent
      @close="handleInvoiceClose"
    >
      <template #title>
        <div class="custom-header send">
          <div class="custom-header-title">{{ $t('game.getInvoiceTitle') }}</div>
        </div>
      </template>
      <div class="send-content">
        <div class="send-content-title">
          {{ $t('game.getInvoiceTips') }}
        </div>
        <div class="email">
          <input
            ref="invoiceEmailInput"
            class="send-content-input"
            :class="{ error: !!sendInvoiceErrorTips }"
            type="text"
            autocomplete="off"
            :placeholder="$t('game.getInvoiceTips1')"
            v-model="mail_data.mail"
            :disabled="!isReceiptEmailEdit"
            @focus="onEmailInputFocus"
            @input="onEmailInputChange"
            @blur="onEmailInputBlur"
          />
          <div class="input-cancel" v-if="mail_data.mail" @click="sendInvoiceCancel"></div>
          <div class="error-tips" v-if="sendInvoiceErrorTips">{{ sendInvoiceErrorTips }}</div>
          <!-- 邮箱下拉列表：挂在输入框下方，浮层盖住后面的 checkbox 和发送按钮 -->
          <div
            class="email-list-wrap"
            v-if="(mail_data.list || []).length && showEmailList && isReceiptEmailEdit"
            @touchstart.stop
            @touchmove.stop
          >
            <div class="email-list" :class="{ 'email-list--ios': os === 'ios' }">
              <div
                v-for="(item, index) in mail_data.list || []"
                :key="index"
                class="email-list-item"
                @click.stop.prevent="onSelectInvoiceEmail(item)"
              >
                <span class="email-list-item-text">{{ item.mail }}</span>
                <img
                  class="email-list-item-delete"
                  src="@/assets/image/delete.png"
                  @click.stop="onDeleteInvoiceEmail(index)"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="checkbox">
          <div
            v-if="isReceiptEmailEdit"
            class="agree-item agree-date"
            @click="mail_data.is_remember = !mail_data.is_remember"
          >
            <div class="icon" :class="{ active: mail_data.is_remember }"></div>
            <div class="text">{{ $t('game.getInvoiceTips2') }}</div>
          </div>
          <div
            class="agree-item"
            @click="mail_data.is_send_information = !mail_data.is_send_information"
          >
            <div class="icon" :class="{ active: mail_data.is_send_information }"></div>
            <div class="text">{{ $t('game.getInvoiceTips3') }}</div>
          </div>
        </div>
      </div>
      <template #confirm>
        <div class="button" @click="sendInvoice">{{ $t('game.invoiceSend') }}</div>
      </template>
    </Dialog>

    <!-- 登录功能 -->
    <transition name="login">
      <LoginModal
        v-if="apploginis"
        @isMobile="isMobile"
        @gameid="gameid"
        @loginSuccess="loginSuccess"
      ></LoginModal>
    </transition>

    <!-- userid引导框 -->
    <ImgTips
      v-if="qusetionis"
      :pics="gameConfig.guide_pic_list"
      @close="qusetionis = false"
    ></ImgTips>

    <!-- 支付验证码  -->
    <!--  -->
    <CaptchaDialog
      v-if="captchaVisible"
      :gameId="gameid"
      :captchaRequestId="captchaRequestId"
      @closeCaptchaDialog="closeCaptchaDialog"
      @success="captchaSuccess"
      @verifyCaptchaAfter="onVerifyCaptchaAfter"
    />

    <!-- 支付弹框 - 收银台 -->
    <transition name="order-checkout">
      <PayConfirm
        v-if="showPayComponent"
        ref="payalert"
        :pack="pack"
        @close="closePayConfirm"
        :pay_info="payinfo"
        :mount="mount"
        :airwallex_deviceid="airwallex_deviceid"
        :currency="conutry.money"
        :last_gateway="last_gateway"
        @updatePayinfo="updatePayinfo"
      />
    </transition>
    <!-- 支付弹框 - 付款 -->
    <transition name="order-checkout">
      <Primer
        v-if="cardpayis && paysty === 'primer'"
        :payinfo="payinfo"
        :mount="mount"
        :airwallex_deviceid="airwallex_deviceid"
      ></Primer>
      <Ayden v-if="cardpayis && paysty === 'adyen'" :payinfo="payinfo" :mount="mount"> </Ayden>
    </transition>

    <!-- 弹屏活动弹窗 -->
    <BonusRewardPopup
      v-if="activeActivityPopup && activeActivityPopup.id === 'bonus-reward'"
      :data="activeActivityPopup.data"
      @close="closeActivityPopup"
    />

    <!-- 游戏登录 -->
    <LoginFromGame />
  </div>
</template>

<script>
let Base64 = require('js-base64').Base64
import './game.css'
import {
  getinvoice,
  adyen_payments_details,
  packagesinfo,
  getCodeInfo,
  checkCanPay,
  checkfpid,
  getPspOrder,
  getPspOrderInfo,
  auth_login,
  getInvoiceEmail,
  deleteMailInfo,
} from '@/api/index.js'
import { isEnteredFromInstalledWebApp } from '@/tool/pwaEntry'
import { PRIMER_ORDER_STATUS } from '@/enum/index.js'
import { getCallPaymentLimitTrackingProps } from '@/tool/packagePurchaseLimit'
import PaymentLog from '../tool/payment.js'

//新版本支付弹框
import PayConfirm from '@/components/common/payalert.vue'
import Primer from '@/components/common/primer/index.vue'
import Ayden from '@/components/common/ayden.vue'

import Foot from '@/components/common/foot.vue'
import Announcement from '@/components/common/announcement.vue'
import LoginModal from '@/components/common/loginModal/login.vue'
import ToggleRole from '@/components/common/loginModal/toggleRole.vue'
import HomeUserInfo from '@/components/common/userCard/homeUserInfo.vue'
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex'
import conutryarr from '@/components/common/country.js'
import Captcha from '@/components/common/Captcha'
import { nanoid } from 'nanoid'
import dayjs from 'dayjs'
import ShopTips from '@/components/shopTips.vue'
import ImgTips from '@/components/common/imgTips.vue'

import GiftSection from '@/features/gift/GiftSection.vue'
import { initGiftPlugins } from '@/features/gift/manager'
import { PopupQueue } from '@/tool/popupQueue'
import { initPopupActivities } from '@/features/popup-activities/registry'
import { reportEventsRead } from '@/features/popup-activities/plugins/bonus-reward/index'
import CaptchaDialog from '@/components/common/Captcha/index.vue'
import PayResult from '@/components/common/PayResult.vue'
import LoginFromGame from '@/components/common/loginModal/LoginFromGame.vue'
import GameTaskRewards from '@/components/common/task.vue'

import HomeStickyFat from '@/components/common/userCard/HomeStickyFat.vue'
import BonusRewardPopup from '@/features/popup-activities/plugins/bonus-reward/ui/BonusRewardPopup.vue'
import mixinCheckTaxExpires from '@/mixins/mixinCheckTaxExpires.js'

export default {
  name: 'game',
  mixins: [mixinCheckTaxExpires],
  components: {
    HomeStickyFat,
    Foot,
    Announcement,
    LoginModal,
    ToggleRole,
    Captcha,
    PayConfirm,
    Ayden,
    Primer,
    HomeUserInfo,
    ShopTips,
    ImgTips,
    GiftSection,
    CaptchaDialog,
    PayResult,
    LoginFromGame,
    GameTaskRewards,
    BonusRewardPopup,
  },
  computed: {
    ...mapGetters(['isShowPostCode']),
    ...mapState({
      isLogin: (state) => state.user.isLogin,
      userInfo: (state) => state.user.userInfo,
      isNoScroll: (state) => state.app.isNoScroll,
      token: (state) => state.user.token,
      fpid: (state) => state.user.fpid,
      loginType: (state) => state.user.loginType,
      conutry: (state) => state.app.conutry,
      accept: (state) => state.app.accept,
      isMobile: (state) => state.app.isMobile,
      userIpCountry: (state) => state.user.userIpCountry,
      postcode: (state) => state.user.postcode,
      acceptAll: (state) => state.app.acceptAll,
      webMailUid: (state) => state.user.webMailUid,
      gameConfig: (state) => state.config.gameConfig,
      isLogin: (state) => state.user.isLogin,
      seoLang: (state) => state.app.seoLang,
    }),
    game_name: () => process.env.VUE_APP_GAME_NAME,
    /** Banner 宝箱：未登录看 game_config.task_enabled；登录后看 get_role_info 当前角色的 show_entry */
    showTaskRewardsChest() {
      if (!this.activityBanner) return false
      const flag = this.isLogin ? this.gameinfo.show_entry : this.gameConfig.task_enabled
      return Number(flag) === 1
    },
    bannerAlt() {
      const keys = this.seoLang.banner || []
      try {
        return keys
          .map((key) => (this.$te(key) && this.$t(key)) || '')
          .filter((msg) => !!msg)
          .join(', ')
      } catch (error) {
        return ''
      }
    },
  },
  watch: {
    maskstyle(val) {
      if (!val || !this.isLogin) return
      const roleId = this.gameinfo.role_id || this.userInfo?.role_id
      if (roleId) {
        this.getRoleInfo({ data: { role_id: roleId } })
      }
    },
  },
  provide() {
    return {
      newCheckPay: this.checkPay,
      updatePayinfo: this.updatePayinfo,
      getPayinfo: () => {
        return this.payinfo
      },
    }
  },
  data() {
    return {
      pack: {},
      gameinfo: {
        id: '',
        icon: '',
        role_id: '',
        money: 0,
        name: '',
        packagename: '',
        extra_info: {},
        /** /callback/get_role_info user_data */
        has_red_dot: 0,
        /** get_role_info user_data.show_entry：1 展示宝箱，0 隐藏；缺省按展示 */
        show_entry: 0,
      },
      // 活动banner
      activityBanner: '',
      activityBannerLoaded: false,
      // 用户是否在游戏白名单内
      player_whitelist_status: false,
      checktext: '',
      //钱符号
      moneyUnit: '',
      gameid: process.env.VUE_APP_GAME_ID,
      editis: false,
      list: [],
      packageid: '',
      //分享人
      owner: '',
      //礼包字典
      packagedict: {},
      //控制弹框 payfail 支付失败, deliveryfail 充值失败,success 成功
      maskstyle: '',
      orderinfo: {
        OrderID: '',
        TransactionID: '',
        localDate: '',
        real_amount: '',
        pending_review: 0,
      },
      // 获取凭证弹窗
      invoiceis: false,
      //提示图片组
      qusetionis: false,
      //控制支付
      payinfo: {},
      mount: {},
      mail_data: {
        mail: '',
        is_remember: false,
        is_send_information: false,
        mail_token: '',
      },
      emailSended: false,
      selectEmail: '',
      sendInvoiceErrorTips: '',
      //防止误触
      clickis: true,
      provider_order_id: '',
      redirectResult: '',
      pakcageis: true,
      // 当前选择支付方式
      paysty: null,
      // 是否显示对应的支付组件
      showPayComponent: false,
      //
      env: process.env.VUE_APP_ENV,
      payment_log: null,
      gateway_package_ids: {},
      // adyen价格精度 文档地址： https://docs.adyen.com/development-resources/currency-codes/
      adyenDecimalPrecision: 2,
      //用于追踪是否打开链接
      code: '',
      apploginis: false,
      //限制check 连点
      checkis: false,
      getInvoicing: false, // 是否正在生成支付凭证
      applepay_is: false,
      channel: this.$utils.customLocalStorage.getItem('dd_channel') || 'organic',
      session_id: '',
      // 是否展示验证码
      captchaVisible: false,
      // 验证码唯一id
      captchaRequestId: '',
      //用于airwallex封控
      airwallex_deviceid: '',
      //
      cardpayis: false,
      //RU_PSP账单真正的type，后端返回
      ru_psp_payment_type: '',
      //记录上一次支付模式
      last_gateway: '',

      // game_session
      game_session: '',

      tempRoleId: undefined,

      is_RU_GAME: ['20317', '20349'].includes(process.env.VUE_APP_GAME_ID.toString()),
      ruPspPayStatus: '',
      isRuPsp: false,

      isReceiptEmailEdit: true,
      // 点击输入框时展示邮箱列表
      showEmailList: false,
      os:
        window.navigator.userAgent.toLocaleLowerCase().indexOf('android') > -1 ? 'android' : 'ios',

      // 选角弹窗回调
      loginCallback: null,

      cache_email: {
        mail: '',
        is_remember: false,
        is_send_information: false,
        mail_token: '',
      },
      hasJoinPwa: false,
      isPwa: isEnteredFromInstalledWebApp(),

      // 弹屏活动队列管理器
      popupQueue: new PopupQueue(),
      activeActivityPopup: null, // 当前展示的活动弹窗 { id, data }
    }
  },
  async created() {
    this.$root.Bus.$on('payAgain', () => {
      this.showPayComponent = false
      this.cardpayis = false
      this.$nextTick(() => this.payAgain())
    })
    this.$root.Bus.$on('updatePackageInfo', this.getPackageInfo)

    this.$rum.report(
      'page_show',
      {
        url: window.location.href,
      },
      3
    )

    this.setShowLoading(true)

    if (this.getQueryString('list_id')) {
      this.list_id = this.getQueryString('list_id')
    }

    //获取用户的登录信息
    if (this.getQueryString('uid')) {
      //先取url的id
      this.gameinfo.id = this.getQueryString('uid')
      this.SET_LOGIN_TYPE(this.$utils.customLocalStorage.getItem('vptyp'))
    } else {
      var uid = this.$utils.customLocalStorage.getItem('session')

      //没有的话查看本地是否有uid
      if (uid && uid != '') {
        //如果没有token id为空
        this.SET_LOGIN_TYPE(this.$utils.customLocalStorage.getItem('vptyp'))
        this.gameinfo.id = this.decode(uid)
      }
    }

    if (this.getQueryString('pack')) {
      this.packageid = this.getQueryString('pack')
    }
    if (this.getQueryString('owner')) {
      this.owner = this.getQueryString('owner')
    }

    if (this.getQueryString('provider_order_id')) {
      this.provider_order_id = this.getQueryString('provider_order_id')
    }

    if (this.getQueryString('gateway')) {
      this.paysty = this.$enum.PAY_WAY_MAP[this.getQueryString('gateway')]
    }

    if (this.getQueryString('fe_t')) {
      this.$router.replace({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          fe_t: undefined,
        },
      })
    }

    if (this.getQueryString('session_id')) {
      this.game_session = this.getQueryString('session_id')
      // session 用完一次作废了，清楚 url 上的 session_id
      this.$router.replace({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          session_id: undefined,
        },
      })
    }

    if (this.getQueryString('code')) {
      this.code = this.getQueryString('code')
      this.$router.replace({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          code: undefined,
        },
      })
      const codeRes = await this.getCodeInfo(this.code)
      if (codeRes.channel_name) {
        this.channel = codeRes.channel_name
        this.$utils.customLocalStorage.setItem('dd_channel', codeRes.channel_name)
      }
    }

    this.$ta.setSuperProperties({
      from: this.channel,
      env: process.env.VUE_APP_TA_ENV,
    })

    //支付上报初始化
    this.payment_log = new PaymentLog()
    this.payment_log.init({
      fornt_name: 'web-vip-mall',
    })
    this.$rum.setShareProperties({
      gameid: this.gameid,
    })
    this.$root.Bus.$on('sendmsg', (obj) => {
      if (obj.event) {
        if (obj.event == 'logout') {
          this.logout(obj)
        } else if (obj.event == 'login') {
          // 登录前检测是否需要展示cookie弹窗
          if (!this.accept) {
            this.popupQueue.addBlocker('cookie')
            this.$root.Bus.$emit('showCookie', () => {
              this.popupQueue.removeBlocker('cookie')
              this.setShowLoginModal(true)
            })
          } else {
            this.setShowLoginModal(true)
          }
        } else if (obj.event == 'applogin') {
          this.checkidSuccessCallback(obj.data)
        } else if (obj.event == 'in_game_login') {
          this.checkidSuccessCallback(obj.data)
        }
      }
    })

    this.getGameInfo()
  },
  mounted() {
    //判断其他页面是否有登录，这个函数当前页面不回触发。
    this.SET_TOKEN(
      this.$utils.customSessionStorage.getItem('vpses') ||
        this.$utils.customLocalStorage.getItem('vplocl')
    )
    window.addEventListener('storage', this.onStorageChange)
    document.addEventListener('visibilitychange', this.onVisibilitychange)
    if (!this.$utils.isHideAirwallex()) {
      this.airwallexDeviceFingerprinting(nanoid())
    }
  },
  beforeDestroy() {
    //为了防止多标签页登录的时候，登录状态改变时，能够通知老页面登录。
    window.removeEventListener('storage', this.onStorageChange)
    document.removeEventListener('visibilitychange', this.onVisibilitychange)
    if (this._packageResetRefreshTimer) {
      clearTimeout(this._packageResetRefreshTimer)
      this._packageResetRefreshTimer = null
    }
    if (this._roleInfoPwaRefreshTimer) {
      clearTimeout(this._roleInfoPwaRefreshTimer)
      this._roleInfoPwaRefreshTimer = null
    }
    if (this._roleInfoExposeRefreshTimer) {
      clearTimeout(this._roleInfoExposeRefreshTimer)
      this._roleInfoExposeRefreshTimer = null
    }
  },
  methods: {
    ...mapActions('app', ['setShowLoading', 'FETCH_GAME_SCHEME']),
    ...mapActions('config', ['FETCH_GAME_CONFIG']),
    ...mapMutations('app', ['SET_IS_PRODUCTION_TAX']),
    ...mapMutations(['SET_TOKEN', 'SET_LOGIN', 'SET_LOGOUT', 'SET_LOGIN_TYPE', 'SET_WEB_MAIL_UID']),
    cleanUrlQuery() {
      const cleanUrl = window.location.origin + window.location.pathname
      window.history.pushState({ path: cleanUrl }, '', cleanUrl)
    },
    //用于airwallex生成密钥指纹，因为无法判断拉起是哪个所以全部要加，最终其实是有助于提高支付通过率,每次页面加载时候重新生成。
    airwallexDeviceFingerprinting(orderSessionId) {
      this.airwallex_deviceid = orderSessionId
      //创建订单时，先删除旧的script
      const el = document.getElementById('airwallex-fraud-api')
      if (el) el.remove()
      //删除后在添加。
      const existingScript = document.getElementById('airwallex-fraud-api')
      if (existingScript) return // 防止重复加载
      const script = document.createElement('script')
      script.type = 'text/javascript'
      script.async = true
      script.id = 'airwallex-fraud-api'
      script.dataset.orderSessionId = orderSessionId
      script.src =
        process.env.VUE_APP_ENV == 'prod'
          ? 'https://static.airwallex.com/webapp/fraud/device-fingerprint/index.js'
          : 'https://static-demo.airwallex.com/webapp/fraud/device-fingerprint/index.js'
      document.body.appendChild(script)
    },
    /**
     * 关闭验证码弹窗
     *
     * @param {boolean} isClosePayConfirm - 是否关闭支付确认弹窗
     */
    closeCaptchaDialog(isClosePayConfirm) {
      if (isClosePayConfirm) {
        this.showPayComponent = false
      }
      this.captchaVisible = false
    },

    /**
     * 验证码验证后的回调方法
     *
     * @param result 验证码验证结果
     */
    onVerifyCaptchaAfter(result) {
      this.$ta.track('vipmall_captcha', {
        result,
        payment_type: this.paysty == 'ayden' || this.paysty == 'primer' ? 'card' : this.paysty,
        index_id: this.captchaRequestId,
        server_id: this.gameinfo.extra_info.value,
        lang: this.$i18n.locale,
        to_type: this.$enum.LOGIN_TYPE[this.loginType],
        ...(this.$store.state.app.fromInstalledWebApp ? { open_ui_old: 'desktop_shortcut' } : {}),
      })
    },

    onStorageChange(e) {
      // 监听是否是 session 登录，如果是则把新的 token 存到 sessionStorage 里面
      if (e.key === this.$utils.getStorageKey('ss_act')) {
        const token = e.newValue
        if (token) {
          this.$utils.customSessionStorage.setItem('vpses', token)
        } else {
          this.$utils.customSessionStorage.removeItem('vpses')
        }
      }
      if (
        e.key === this.$utils.getStorageKey('vplocl') ||
        e.key === this.$utils.getStorageKey('vpses') ||
        e.key === this.$utils.getStorageKey('session')
      ) {
        console.log('Storage 刷新')
        this.showLoginStatusChangeModal()
      }
    },
    showLoginStatusChangeModal() {
      this.$confirm({
        content: this.$t('login.loginChange'),
        hideCancel: true,
        hideClose: true,
        confirm: () => {
          window.location.reload(true)
        },
      })
    },
    onVisibilitychange() {
      if (!document.hidden) {
        console.log('页面显示了')
        const localToken =
          this.$utils.customSessionStorage.getItem('vpses') ||
          this.$utils.customLocalStorage.getItem('vplocl')
        if (this.token !== localToken) {
          console.log('Visibilitychang 刷新')
          this.showLoginStatusChangeModal()
          return
        }
        // 刷新任务
        this.scheduleTaskInfoRefreshOnVisible()
        // web
        if (!this.isPwa) {
          this.scheduleRoleInfoRefreshOnPwaVisible()
          return
        }
        // 曝光时请求 getRoleInfo（1s 防抖）
        this.scheduleRoleInfoRefreshOnExpose()
      }
    },
    /** 页面回到前台：先刷新 get_role_info，再刷新 /task_info（弹窗打开时） */
    async scheduleTaskInfoRefreshOnVisible() {
      if (!this.isLogin) return
      const roleId = this.gameinfo.role_id || this.userInfo?.role_id
      if (roleId) {
        await this.getRoleInfo({ data: { role_id: roleId } })
      }
      this.$refs.gameTaskRewards?.refreshTaskInfoIfModalOpen?.()
    },
    /** PWA / 主屏幕：回到前台且处于 standalone 时 debounce 刷新角色信息；任务弹窗打开时同步刷新 /task_info */
    scheduleRoleInfoRefreshOnPwaVisible() {
      if (this.hasJoinPwa || !isEnteredFromInstalledWebApp() || !this.isLogin) return

      this.hasJoinPwa = true
      if (Number(this.gameinfo.show_entry) === 0) return
      const roleId = this.gameinfo.role_id || this.userInfo?.role_id
      if (!roleId) return
      this.$refs.gameTaskRewards?.closeTaskRewardsModal?.()
      if (this._roleInfoPwaRefreshTimer) {
        clearTimeout(this._roleInfoPwaRefreshTimer)
      }
      this._roleInfoPwaRefreshTimer = setTimeout(() => {
        this._roleInfoPwaRefreshTimer = null
        this.getRoleInfo({ data: { role_id: roleId } })
      }, 300)
    },
    /** PWA 页面回到前台：debounce 1s 后刷新 get_role_info */
    scheduleRoleInfoRefreshOnExpose() {
      const roleId = this.gameinfo.role_id || this.userInfo?.role_id
      if (!roleId) return
      if (this._roleInfoExposeRefreshTimer) {
        clearTimeout(this._roleInfoExposeRefreshTimer)
      }
      this._roleInfoExposeRefreshTimer = setTimeout(() => {
        this._roleInfoExposeRefreshTimer = null
        this.getRoleInfo({ data: { role_id: roleId } })
      }, 1000)
    },
    setShowLoginModal(sty) {
      this.apploginis = sty
      this.$rum.report('login_moadl_open', {}, 3)
    },
    async getCodeInfo(code) {
      try {
        const res = await getCodeInfo({
          code,
          game_id: this.gameid,
        })
        if (res.data.code === 1) {
          return res.data.data
        }
        return {}
      } catch (error) {
        console.log(error)
        this.$rum.report(error)
        return {}
      }
    },
    invoicetext(paysty) {
      var paymentLabel

      switch (paysty) {
        case 'paypay':
          paymentLabel = this.$t('paymentMethod.Paypay')
          break
        case 'kakao':
          paymentLabel = this.$t('paymentMethod.KakaoPay')
          break
        case 'paypal':
          paymentLabel = paysty
          break
        case 'google_pay':
          paymentLabel = 'Google Pay'
          break
        case 'apple_pay':
          paymentLabel = 'Apple Pay'
          break
        case 'payermax':
          paymentLabel = this.ru_psp_payment_type
          break
        case 'deepgrow':
          paymentLabel = this.ru_psp_payment_type
          break
        default:
          paymentLabel = 'Card'
      }

      return paymentLabel
    },
    //加密
    encode(str) {
      return Base64.encode(str)
    },
    //解密
    decode(str) {
      return Base64.decode(str)
    },
    logout(obj) {
      if (obj && obj.noAlert && obj.noAlert == true) {
        this.logoutAndClearData()
        setTimeout(() => {
          this.apploginis = true
        }, 1000)
      } else {
        this.$confirm({
          content: this.$t('game.changeaccount'),
          hideClose: true,
          confirm: () => {
            this.logoutAndClearData()
          },
        })
      }
    },
    //退出并
    logoutAndClearData(noLog = false) {
      this.editis = false
      if (!noLog) {
        const taData = {
          operator_type: 2,
          index_id: this.$ta.getDistinctId(),
          to_type: this.$enum.LOGIN_TYPE[this.loginType],
          ...(this.$store.state.app.fromInstalledWebApp ? { open_ui_old: 'desktop_shortcut' } : {}),
        }
        if (this.gameid === '20195') {
          taData.is_web_unlock = this.userInfo.pay_threshold === 1
        }
        this.$ta.track('vip_mall_combine', taData)

        this.$rum.report(
          'login_operator_type',
          {
            operator_type: 2,
            to_type: this.$enum.LOGIN_TYPE[this.loginType],
          },
          2
        )
      }

      this.$ta.unsetSuperProperty('fake_id')
      this.$ta.unsetSuperProperty('to_type')
      this.$ta.unsetSuperProperty('server_id')
      this.$ta.logout()

      this.$utils.customLocalStorage.removeItem('vplocl')
      this.$utils.customSessionStorage.removeItem('vpses')
      this.$utils.customLocalStorage.removeItem('vptyp')
      this.$utils.customLocalStorage.removeItem('session')
      this.SET_LOGOUT()
      this.SET_TOKEN(null)

      //清空信息
      this.$set(this.gameinfo, 'id', '')
      this.$set(this.gameinfo, 'icon', '')
      this.$set(this.gameinfo, 'name', '')
      this.$set(this.gameinfo, 'role_id', '')
      this.$set(this.gameinfo, 'extra_info', {})
      this.$set(this.gameinfo, 'has_red_dot', 0)
      this.$set(this.gameinfo, 'show_entry', 0)
      this.$set(this.gameinfo, 'player_whitelist_status', false)
      this.player_whitelist_status = false

      this.$store.commit('SET_USERINFO', {})
      this.$store.commit('SET_ROLE_LIST', [])

      // 由于airwallex脚本无法清除所以退出登录时需要刷新页面。
      if (!noLog) {
        setTimeout(() => {
          const url = location.origin + location.pathname + '?fe_t=' + new Date().getTime()
          window.location.href = url
        }, 200)
      }
    },
    paychange(item) {
      this.paysty = item
      //判断当前商品是否在当前支付方式中
      if (this.gateway_package_ids[this.$enum.GATEWAY_MAP[this.paysty]]) {
        this.idarr = this.gateway_package_ids[this.$enum.GATEWAY_MAP[this.paysty]]
        if (!this.idarr.includes(this.packageid)) {
          this.clearid()
        }
      }
    },
    pspCheck() {
      // psp预订单号
      if (this.getQueryString('outTradeNo')) {
        this.redirectResult = this.getQueryString('tradeToken')
        var obj = {}
        obj.uuid = this.getQueryString('tradeToken')
        obj.provider_order_id = this.getQueryString('outTradeNo')
        obj.game_id = this.gameid
        this.isRuPsp = true
        this.payment_log.set_properties({
          cg_request_id: obj.provider_order_id,
          user: this.gameinfo.id,
          gateway: this.paysty,
          appid: this.gameConfig.appid + '',
        })

        this.payment_log.report('web_payment_check_start')
        this.ruPspPayStatus = this.getQueryString('status') || this.getQueryString('pay_status')
        this.pspCheckInfo(obj)
      }
    },
    //请求RU PSP支付结果
    pspCheckInfo(obj) {
      this.popupQueue.addBlocker('payResult')
      this.payment_log.set_properties({
        cg_request_id: obj.provider_order_id + '',
      })

      getPspOrderInfo(obj)
        .then((response) => {
          const res = response.data
          const resData = res.data
          if (response === false || res.code == 15030) {
            return
          }
          if (res.code == 1) {
            this.ru_psp_payment_type = resData.payment_method_type
            this.paysty = resData.payment_type
          }
          if (res.code == 1 && resData.status === 1) {
            this.moneyUnit = resData.currency_label
            this.successpay(resData)
            this.payment_log.set_properties({
              transaction_id: resData.transaction_id || '',
            })
            this.$utils.customSessionStorage.setItem('provider_order_id', obj.provider_order_id)
            this.payment_log.report('web_payment_check_success')
          } else if (res.code == 1 && resData.order_status === 3) {
            this.failpay({
              data: {
                uuid: resData.uuid,
                now_timestamp: resData.now_timestamp,
                fail_code: 'pay.limitPackBuyFail',
                real_amount: resData.real_amount,
              },
            })
            this.payment_log.report('web_payment_check_fail', {
              code: 4,
              msg: 'ru_psp ship blocked',
            })
          } else if (this.ruPspPayStatus == 'SUCCESS' || this.ruPspPayStatus == 'success') {
            this.setShowLoading(true)
            setTimeout(() => {
              this.ruPspPayStatus = 'retry'
              this.pspCheckInfo(obj)
              this.setShowLoading(false)
            }, 3000)
          } else {
            this.failpay(res)
            this.payment_log.report('web_payment_check_fail', {
              code: 3,
              msg: res.msg || 'psp failed',
            })
          }
          this.setShowLoading(false)
          // 不刷新页面的情况下，更新浏览器地址栏的 UR
          this.cleanUrlQuery()
        })
        .catch((error) => {
          this.failpay(error)
          this.payment_log.report('web_payment_check_error', {
            code: 2,
            msg: error,
          })
          throw Error(error)
        })
    },
    adyencheckagain() {
      if (this.getQueryString('redirectResult')) {
        this.redirectResult = this.getQueryString('redirectResult')
        this.paychange(this.paysty)
        var obj = {}
        obj.details = {
          redirectResult: decodeURI(this.redirectResult),
        }

        this.payment_log.set_properties({
          cg_request_id: this.provider_order_id + '',
          user: this.gameinfo.id,
          gateway: this.paysty,
          appid: this.gameConfig.appid + '',
        })
        this.payment_log.report('web_payment_check_success')
        this.payment_log.report('web_payment_checkAgain_start')

        this.detailresult({
          provider_order_id: this.provider_order_id,
          details: JSON.stringify(obj),
        })
      }
    },
    // 获取游戏信息
    async getGameInfo() {
      try {
        await this.FETCH_GAME_CONFIG(this.gameid)

        // 如果有用户 id 或 game_session 则尝试登录
        if (this.gameinfo.id || this.game_session) {
          if (!this.accept) {
            this.popupQueue.addBlocker('cookie')
            this.getPackageInfo()
            this.$root.Bus.$emit('showCookie', () => {
              this.popupQueue.removeBlocker('cookie')
              this.doLogin()
            })
          } else {
            this.doLogin()
          }
        } else {
          if (this.token && !this.isLogin) {
            this.$utils.customLocalStorage.removeItem('vplocl')
            this.$utils.customSessionStorage.removeItem('vpses')
          }
          this.$ta.track('vip_mall_view', {
            ...(this.$store.state.app.fromInstalledWebApp
              ? { open_ui_old: 'desktop_shortcut' }
              : {}),
          })
          this.getPackageInfo()
        }
      } catch (error) {
        console.log(error)
      }
      //检测ayden是否有调回来的支付结果
      this.adyencheckagain()
      //检测psp是否有调回来的支付结果
      this.pspCheck()
    },
    updateProviderOrderId(id) {
      this.provider_order_id = id
    },
    // 发送凭据
    sendInvoice() {
      if (!this.mail_data.mail) {
        this.sendInvoiceErrorTips = this.$t('primer.empty')
        return
      } else if (!this.$utils.validateEmail(this.mail_data.mail)) {
        this.sendInvoiceErrorTips = this.$t('primer.error')
        return
      }
      this.sendInvoiceErrorTips = ''
      //console.log('send')
      if (this.provider_order_id == '') {
        this.provider_order_id = this.$utils.customSessionStorage.getItem('provider_order_id')
      }
      if (this.getInvoicing) return

      this.getInvoicing = true

      var obj = {
        game_id: this.gameid,
        email: this.mail_data.mail,
        is_remember: this.mail_data.is_remember + '',
        is_send_information: this.mail_data.is_send_information + '',
        provider_order_id: this.provider_order_id,
        language_code: this.$i18n.locale,
        transaction_time: this.orderinfo.localDate,
        web_mail_uid: this.webMailUid || '',
        mail_token: this.mail_data.mail_token || '',
      }

      //console.log(obj)
      getinvoice(obj)
        .then((res) => {
          if (res.data.code == 1) {
            this.emailSended = true
            this.invoiceis = false
            if (this.mail_data.is_remember == false) {
              this.$set(this.mail_data, 'mail', '')
            }
            this.$toast(this.$t('game.sendSuccess'))
            this.SET_WEB_MAIL_UID(res.data.data.web_mail_uid || '')
          } else {
            this.$toast(res.data.msg)
          }
          this.getInvoicing = false
        })
        .catch((err) => {
          this.$toast('request error')
          this.getInvoicing = false
        })
    },
    //支付
    pspPay(obj) {
      this.payment_log.report('web_payment_getorder_start')
      obj.user_id = this.gameinfo.id
      const uid = this.$utils.customLocalStorage.getItem(`web_shopper_uid_${this.fpid}`)
      if (uid) {
        obj.web_shopper_uid = uid
      }
      obj.language = this.$i18n.locale
      obj.cg_request_id = ''
      obj.enter_type = this.loginType
      obj.bonus = this.$store.state.user.isFirst ? 1 : 0
      setTimeout(() => {
        this.setShowLoading(true)
      }, 0)
      getPspOrder(obj)
        .then((res) => {
          //校验黑名单之类的
          if (!this.checkPay(res)) {
            this.setShowLoading(false)
            return false
          }

          if (res.data.code == 1) {
            if (res.data.data.web_shopper_uid) {
              this.$utils.customLocalStorage.setItem(
                `web_shopper_uid_${this.fpid}`,
                res.data.data.web_shopper_uid
              )
            }

            this.payment_log.set_properties({
              cg_request_id: res.data.data.provider_order_id + '',
            })
            // 记录购买的礼包 id，用于失败重新购买
            if (this.pack.pack_index) {
              this.$utils.customSessionStorage.setItem('psp_package_index', this.pack.pack_index)
            }

            this.payment_log.report('web_payment_getorder_success')
            window.location.href = res.data.data.redirect_url
            setTimeout(() => {
              this.setShowLoading(false)
            }, 2000)
          } else {
            this.failpay('Order failed！')
            this.payment_log.report('web_payment_getorder_fail', {
              code: 3,
              msg: res.data.msg ? res.data.msg : 'Order failed',
            })
            this.$rum.report(
              'pay_err',
              {
                paystyle: 'RU_PSP',
                type: 'getorder',
                response: res.data,
                prams: obj,
              },
              3
            )
            this.setShowLoading(false)
          }
        })
        .catch(() => {
          //this.setShowLoading(false)
        })
    },
    //拉黑以及限时商品检测
    checkPay(res) {
      const config = {
        content: '',
        cb: () => {},
      }
      switch (res.data.code) {
        // 判断年龄是否合规，中断购买流程
        case 10103002:
          config.content = res.data.data.age_tips
          config.cb = () => {
            this.showPayComponent = false
            this.cardpayis = false
          }
          break
        // 活动列表是有变化直接提示弹窗，中断购买流程
        case 10103003:
          config.content = this.$t('game.shopUpdated')
          config.cb = () => {
            window.location.reload(true)
          }
          break
        // 在黑名单内
        case 10103001:
          config.content = this.$te(`identify.inBlacklist_${this.gameid}`)
            ? this.$t(`identify.inBlacklist_${this.gameid}`)
            : this.$t(`identify.inBlacklist`)
          config.cb = () => {
            this.showPayComponent = false
            this.cardpayis = false
          }
          break
        // 在暂时封禁名单内
        case 101031009:
          config.content = this.$te(`toast.blackTips_${this.gameid}`)
            ? this.$t(`toast.blackTips_${this.gameid}`)
            : this.$t(`toast.blackTips`)
          config.cb = () => {
            this.showPayComponent = false
            this.cardpayis = false
          }
          break
        // 税率超时
        case 101031012:
          config.content = this.$t('order.updateTips')
          config.cb = () => {
            this.$root.Bus.$emit('payAgain')
          }
          break
        // 等级不足
        case 101031022:
          config.content = this.$t(`game.payTipsLevel_${this.$store.state.app.gameId}`)
          config.cb = () => {
            this.showPayComponent = false
            this.cardpayis = false
          }
          break
      }
      if (config.content) {
        this.$confirm({
          content: config.content,
          hideClose: true,
          hideCancel: true,
          confirm: config.cb,
        })
        return false
      } else {
        return true
      }
    },
    //去确认订单---目前用于RU_PSP
    async gotodetail() {
      if (!this.packageid) return
      if (!this.editis) return

      const curPackage = this.packagedict['package' + this.packageid].package

      if (this.packageid == '') {
        return (this.pakcageis = false)
      } else {
        this.pakcageis = true
      }

      this.setShowLoading(true)
      try {
        const res = await checkCanPay({
          game_id: this.gameid,
        })
        if (res.data.code === 1) {
          // 更新当前capture校验的request_id
          this.captchaRequestId = res.data.data.request_id

          // 0:未开启 capture 1. 已开启 capture，未匹配规则 2. 已开启capture且匹配规则
          const capture_status = res.data.data.capture_status
          this.capture_status = capture_status

          // 1.captcha未开启——可以请求预订单
          // 2.开启captcha且未命中 captcha 规则——可以请求预订单
          // 3.开启captcha且命中 captcha 规则——弹验证
          //capture_status 状态 0:未开启 capture 1. 已开启 capture，未匹配规则 2. 已开启capture且匹配规则

          const taData = {
            iap_product_id: curPackage.package_id,
            payment_type: this.paysty == 'ayden' || this.paysty == 'primer' ? 'card' : this.paysty,
            operator_type: 4,
            amount: curPackage.final_amount,
            currency: this.conutry.money,
            server_id: this.gameinfo.extra_info.value,
            index_id: this.captchaRequestId,
            result: capture_status + 1,
            ...getCallPaymentLimitTrackingProps(this.packagedict['package' + this.packageid]),
            ...(this.$store.state.app.fromInstalledWebApp
              ? { open_ui_old: 'desktop_shortcut' }
              : {}),
          }
          if (this.gameid === '20195') {
            taData.iap_name = curPackage.data_name || ''
            taData.pkg_id = curPackage.pack_id || ''
            taData.reward = curPackage.reward || ''
          }
          this.$ta.track('call_payment', taData)

          // 后台开启capture,且当前用户命中规则
          if (capture_status === 2) {
            // await this.getCaptchaCode();
            this.captchaVisible = true
          } else {
            // 直接拉起支付
            this.pay()
          }
        }
      } catch (error) {
        this.$rum.report(error)
      } finally {
        this.setShowLoading(false)
      }
    },
    //用于支付弹框打开外部
    openPay() {
      if (!this.mixinCheckTaxExpires()) {
        return false
      }
      this.payinfo.gateway = this.$enum.GATEWAY_MAP[this.paysty]
      this.cardpayis = true
    },
    //支付---目前用于RU_PSP
    pay() {
      if (this.editis == true && this.packageid != '') {
        this.buildPayInfo()
        if (this.isRuPsp) {
          this.pspPay(this.payinfo)
        } else {
          this.showPayComponent = true
        }
        this.payment_log.report('web_payment_buy_start')
      }
    },
    buildPayInfo() {
      const currentPackage = this.packagedict['package' + this.packageid]
      console.log('fat-buildPayInfo', this.packagedict, this.packageid, currentPackage)
      var obj = {
        game_id: this.gameid,
        product_id: currentPackage.package.package_id,
        pack: currentPackage.real_id || currentPackage.id,
        list_id: currentPackage.list_id,
        owner: this.owner,
        amount: currentPackage.package.final_amount,
        currency: this.conutry.money,
        currency_label: this.moneyUnit,
        // gateway和os, 国内支付宝和微信预订单接口特有参数，需要到第二次层级选择后填充。
        gateway: '',
        os: this.os,
        package_type: currentPackage.package_type || 1,
        //新增id
        role_id: this.gameinfo.role_id,
        real_role_id: this.gameinfo.real_role_id,
        channel_from: this.channel,
        tga_os: this.$ta.getPresetProperties().toEventPresetProperties()['#os'],
        // 新增验证码id
        request_id: this.captchaRequestId,
        login_type: this.loginType,
        package_info: '{}',
        data_name: currentPackage.data_name || '',
        pack_id: currentPackage.pack_id || '',
        reward: currentPackage.reward || '',
      }
      console.log('fat-buildPayInfo', { ...obj })
      if (this.gameinfo.extra_info && this.gameinfo.extra_info.key) {
        obj.user_extra_key = this.gameinfo.extra_info.key
        obj.user_extra_value = this.gameinfo.extra_info.value
      }

      if (this.game_session && currentPackage.isOnlyBuy) {
        obj.session_id = this.game_session
      }

      var mountobj = {}
      mountobj.value = Math.round(
        currentPackage.package.final_amount * Math.pow(10, this.adyenDecimalPrecision)
      )
      mountobj.currency = this.conutry.money
      this.$set(this, 'mount', mountobj)

      //清空订单号
      this.$set(this, 'orderinfo', {
        OrderID: '',
        TransactionID: '',
        localDate: '',
        real_amount: '',
      })

      //
      this.payment_log.clear_properties()
      this.payment_log.set_properties({
        user: this.fpid,
        currency_code: this.conutry.money,
        amount: obj.amount,
        product_id: obj.product_id,
        gateway: this.paysty,
        appid: this.gameConfig.appid + '',
      })
      this.payment_log.set_clickid()

      obj.click_id = this.payment_log.logdata.click_id
      this.$set(this, 'payinfo', obj)
    },
    /**
     * 验证码验证成功处理函数
     *
     * @method captchaSuccess
     */
    captchaSuccess() {
      if (this.isRuPsp) {
        this.pay()
      }
      this.$refs.payalert.captchaSuccess(this.captchaRequestId)
    },
    //新版本支付流程
    gotopay() {
      if (this.editis == true && this.packageid != '') {
        this.buildPayInfo()
        this.showPayComponent = true
        this.payment_log.report('web_payment_buy_start')
      }
    },
    //检测detail
    detailresult(obj) {
      this.popupQueue.addBlocker('payResult')
      adyen_payments_details(obj)
        .then((response) => {
          if (response === false || response.data.code == 15030) {
            return false
          }

          if (response.data.code == 1) {
            this.successpay(response.data.data)
            this.payment_log.set_properties({
              transaction_id: response.data.data.transaction_id
                ? response.data.data.transaction_id
                : '',
            })
            this.payment_log.report('web_payment_checkAgain_success')
          } else {
            let langKey = ''
            let uuid = ''
            if (response.data.code == 101031025) {
              langKey = 'pay.limitPackBuyFail'
              uuid = obj.provider_order_id
            } else {
              langKey = response.data.fail_code
              uuid = response.data.uuid
            }
            this.failpay({
              ...response.data,
              data: {
                ...(response.data.data || {}),
                fail_code: langKey,
                uuid: uuid,
              },
            })
            this.payment_log.report('web_payment_checkAgain_fail', {
              code: 3,
              msg: response.data.msg ? response.data.msg : 'adyen_payments_details failed',
            })
          }

          // 获取当前URL
          var url = window.location.href

          // 移除URL中的查询参数
          var index = url.indexOf('?')
          if (index > 0) {
            url = url.substring(0, index)
          }

          // 如果需要，可以将URL设置到当前页面，不刷新页面
          window.history.pushState(
            {
              path: url,
            },
            '',
            url
          )
        })
        .catch((error) => {
          this.failpay(error)
          this.payment_log.report('web_payment_checkAgain_error', {
            code: 2,
            msg: error,
          })
          throw Error(error)
        })
    },
    //子组件支付成功
    successpay(data) {
      console.log('success_pay_data', data)
      this.orderinfo.pending_review = Number(data.pending_review) === 1 ? 1 : 0
      if (data.transaction_id) {
        this.orderinfo.TransactionID = data.transaction_id
      }
      if (data.uuid) {
        this.orderinfo.OrderID = data.uuid
      }

      this.orderinfo.now_timestamp = data.now_timestamp || Date.now()
      this.orderinfo.localDate = dayjs(this.orderinfo.now_timestamp).format('YYYY-MM-DD HH:mm:ss')

      if (data.real_amount) {
        this.orderinfo.real_amount = data.real_amount
      } else {
        this.orderinfo.real_amount = this.gameinfo.money
      }

      this.orderinfo.tax = data.tax
      this.orderinfo.taxed_price = data.taxed_price

      // 支付成功把 postcode 存到 localstorage 里面，用于下次支付
      if (this.isShowPostCode) {
        if (this.acceptAll) {
          this.$utils.customLocalStorage.setItem(`postcode_${this.userIpCountry}`, this.postcode)
        }
      }

      this.cancelpay()
      this.showPayComponent = false
      this.popupQueue.addBlocker('payResult')
      this.popupQueue.removeBlocker('payment')
      this.maskstyle = 'success'
      this.preOpenInvoice()
      this.$rum.report('pay_vip_sucess', data, 1)

      //因为后端有延迟所以前端需要缓存上一次支付成功的支付方式，等使用过一次删除。
      this.$utils.customSessionStorage.setItem('cgpsty', this.paysty)
      //更新礼包
      this.packagereset()
    },
    //支付失败
    failpay(data) {
      this.cancelpay()
      this.showPayComponent = false
      this.popupQueue.addBlocker('payResult')
      this.popupQueue.removeBlocker('payment')
      this.orderinfo.pending_review = 0
      if (data.data) {
        if (data.data.transaction_id) {
          this.orderinfo.TransactionID = data.data.transaction_id
        }
        if (data.data.uuid) {
          this.orderinfo.OrderID = data.data.uuid
        }

        this.orderinfo.now_timestamp = data.data.now_timestamp || Date.now()
        this.orderinfo.localDate = dayjs(this.orderinfo.now_timestamp).format('YYYY-MM-DD HH:mm:ss')

        if (data.data.real_amount) {
          this.orderinfo.real_amount = data.data.real_amount
        } else {
          this.orderinfo.real_amount = this.gameinfo.money
        }

        this.orderinfo.tax = data.data.tax
        this.orderinfo.taxed_price = data.data.taxed_price

        if (data.code == 15012) {
          this.maskstyle = 'success'
        } else {
          this.maskstyle = 'payfail'
        }

        // 失败原因
        this.orderinfo.fail_code = data.data.fail_code || ''
      } else {
        this.orderinfo.real_amount = this.gameinfo.money

        this.orderinfo.now_timestamp = Date.now()
        this.orderinfo.localDate = dayjs(this.orderinfo.now_timestamp).format('YYYY-MM-DD HH:mm:ss')

        this.maskstyle = 'payfail'
      }
      this.$rum.report('pay_vip_fail', data, 1)
    },
    //子组件取消支付
    cancelpay() {
      this.cardpayis = false
    },
    selpackage(item, isClick = false) {
      //未登录直接拉起支付框
      if (this.editis == true) {
        this.popupQueue.addBlocker('payment')
        this.pack = item
        this.$store.commit('app/SET_CUSTOMIZATION_FLAG', item?.customization_flag)

        // 拉起收银台后重置发送邮件状态
        this.emailSended = false

        this.packageid = item.id
        this.pakcageis = true
        this.gameinfo.money = item.package.final_amount
        this.gameinfo.packagename = item.package.package_en_name

        //点击商品时点位
        const taData = {
          server_id: this.gameinfo.extra_info.value,
          iap_product_id: item.package.package_id,
          currency: this.conutry.money,
          amount: item.package.final_amount,
          operator_type: 1,
          tid: '',
          index_id: '',
          use_type: '',
          ...getCallPaymentLimitTrackingProps(item),
          ...(this.$store.state.app.fromInstalledWebApp ? { open_ui_old: 'desktop_shortcut' } : {}),
        }
        if (this.gameid === '20195') {
          taData.iap_name = item.data_name || ''
          taData.pkg_id = item.pack_id || ''
          taData.reward = item.reward || ''
        }
        this.$ta.track('call_payment', taData)

        // 非俄罗斯拉起支付收银台
        if (!this.isRuPsp) {
          this.gotopay()
        }
        // 俄区点击商品直接跳转详情
        if (isClick && this.isRuPsp) {
          this.gotodetail()
        }
      } else {
        this.$root.Bus.$emit('sendmsg', { event: 'login' })
      }
    },
    clearid() {
      this.packageid = ''
      this.gameinfo.money = 0
      this.gameinfo.packagename = ''
      this.$store.commit('app/SET_CUSTOMIZATION_FLAG', 0)
    },
    //礼包更新接口
    packagereset() {
      packagesinfo({
        game_id: this.gameid,
        list_id: this.list_id,
        currency: this.conutry.money,
        language_code: this.$i18n.locale,
      })
        .then((res) => {
          if (res.data.code == 1) {
            if (res.data.data) {
              this.setLastGateway(res.data.data.last_gateway)
            }
          } else {
            // console.log('礼包已经购买成功')
          }
        })
        .finally(() => {
          if (this.loginCallback) {
            try {
              this.loginCallback()
            } catch (error) {
              console.error(error)
            }
          }
          this.loginCallback = null
        })
    },
    async loginSuccess(obj) {
      this.SET_TOKEN(obj.token)
      this.SET_LOGIN_TYPE(obj.login_type)
      if (obj.login_type == 'role_id') {
        this.gameinfo.id = obj.session_id
        await this.checkid('login', obj.fn)
      } else if (obj.login_type == 'role_id_safe') {
        this.gameinfo.id = obj.session_id
        await this.checkid('role_id_safe', obj.fn)
      } else {
        //授权登录
        this.session_id = obj.session_id
        this.tempRoleId = obj.roleId
        await this.checkid('app')
      }
    },

    /**
     * 登录成功后检查id
     * @param {string} sty - 登录方式
     *  login: 输入 role_id 登录
     *  app: app 授权登录
     *  cacheLogin: 缓存登录
     * @param {Function} sucess - 成功回调
     * @returns {Promise<boolean>} - 是否成功
     */
    async checkid(sty = '', sucess = null) {
      if (this.gameinfo.id !== '' || this.session_id != '') {
        if (this.checkis == true) {
          return false
        } else {
          this.checkis = true
        }

        this.$set(this.gameinfo, 'icon', '')
        this.$set(this.gameinfo, 'name', '')
        this.$set(this.gameinfo, 'role_id', '')
        this.$set(this.gameinfo, 'extra_info', {})
        this.$set(this.gameinfo, 'has_red_dot', 0)
        this.$set(this.gameinfo, 'show_entry', 0)
        this.$set(this.gameinfo, 'player_whitelist_status', false)
        this.player_whitelist_status = false

        try {
          let res = null
          var req = {
            game_id: this.gameid,
            channel_from: this.channel,
            tga_os: this.$ta.getPresetProperties().toEventPresetProperties()['#os'],
          }

          if (sty == 'role_id' || this.loginType == 'role_id' || this.loginType == 'role_id_safe') {
            req.role_id = this.gameinfo.id
          }

          res = await checkfpid(req)

          console.log('登录结果----')
          console.log(res)

          this.checkis = false
          if (res.data.code == 1) {
            //通知角色列表
            this.$store.commit('SET_ROLE_LIST', res.data.data.user_data)
            this.$store.commit('SET_USER_IP', res.data.data.ip_country_code)
            this.$store.commit('SET_IS_SHOW_PRODUCTION_TAX_TIPS', res.data.data.show_tax_notice)

            if (sty != 'app' && sty != 'in_game') {
              var dat = ''
              if (this.loginType == 'app' || this.loginType == 'in_game') {
                //判断缓存的角色如果不再返回的列表中登出。
                if (this.gameinfo.id != '') {
                  if (res.data.data.user_data.every((user) => user.role_id !== this.gameinfo.id)) {
                    this.$toast(this.$t('login.nologin'))
                    this.logout({
                      event: 'logout',
                      noAlert: true,
                    })
                    //失败时关闭loading
                    this.setShowLoading(false)
                    this.checkis = false
                    this.getPackageInfo()
                    return false
                  }
                }

                dat = res.data.data.user_data.find((user) => user.user_id === this.gameinfo.id)
              } else {
                dat = res.data.data.user_data[0]
              }

              // 设置rum用户id
              this.$rum.setUserId(dat.user_uid)

              this.checkidSuccessCallback(dat)

              if (sty === 'login' || sty === 'role_id_safe') {
                const taData = {
                  operator_type: 1,
                  server_id: (dat.extra_info && dat.extra_info.value) || '',
                  to_type: this.$enum.LOGIN_TYPE[this.loginType],
                  index_id: this.$ta.getDistinctId(),
                  ...(this.$store.state.app.fromInstalledWebApp
                    ? { open_ui_old: 'desktop_shortcut' }
                    : {}),
                }
                if (this.gameid === '20195') {
                  taData.is_web_unlock = dat.pay_threshold === 1
                }
                this.$ta.track('vip_mall_combine', taData)

                this.$rum.report(
                  'login_operator_type',
                  {
                    operator_type: 1,
                    to_type: this.$enum.LOGIN_TYPE[this.loginType],
                  },
                  1
                )
              }

              if (sty === 'cacheLogin') {
                this.$ta.track('vip_mall_view', {
                  ...(this.$store.state.app.fromInstalledWebApp
                    ? { open_ui_old: 'desktop_shortcut' }
                    : {}),
                })
                this.$rum.report(
                  'cachelogin',
                  {
                    data: res.data,
                    to_type: this.loginType,
                  },
                  3
                )
              }
            } else {
              this.apploginis = false

              this.$root.Bus.$emit('toggleRole', { type: 'select', roleId: this.tempRoleId })
            }
          } else {
            //关闭登录弹框
            this.apploginis = false
            //app登录的时候提示一下
            if (sty == 'app') {
              if (res.data.code == '15034') {
                this.$toast(this.$t('login.find'))
                setTimeout(() => {
                  //再次打开登录框
                  this.apploginis = true
                }, 100)
              } else {
                this.$toast(this.$t('game.loginfail'))
              }
            }

            //去掉登录失效的情况
            if (res.data.code != '15030') {
              //失败上报失败原因
              this.$ta.track('vip_mall_combine', {
                operator_type: 4,
                index_id: this.$ta.getDistinctId(),
                code: res.data ? res.data.code : '',
                to_type: sty == 'app' ? '2' : '1',
                ...(this.$store.state.app.fromInstalledWebApp
                  ? { open_ui_old: 'desktop_shortcut' }
                  : {}),
              })

              this.$rum.report(
                'login_operator_type',
                {
                  operator_type: 1,
                  to_type: sty == 'app' ? '2' : '1',
                  type: 'checkid_err',
                },
                4
              )
            }

            //失败时关闭loading
            this.setShowLoading(false)

            //失败就返回
            if (typeof sucess === 'function') {
              sucess()
            }

            this.checktext = this.$t('game.id404')
            //缓存账号如果异常失败,同时是缓存登录的时候
            if (sty === 'cacheLogin') {
              this.$rum.report(
                'cachelogin_fail',
                {
                  data: res.data,
                  to_type: sty == 'app' ? 'app' : 'id',
                },
                2
              )

              // 维护中和版本更新不清除，其他错误清除登录信息
              if (res.data.code != '15053' && res.data.code != '101031008') {
                this.$utils.customLocalStorage.removeItem('vplocl')
                this.$utils.customSessionStorage.removeItem('vpses')
                this.$utils.customLocalStorage.removeItem('vptyp')
                this.$utils.customLocalStorage.removeItem('session')
              }
              this.gameinfo.id = ''
              //重新拉取列表
              this.getGameInfo()
            }
          }
        } catch (error) {
          this.checkis = false
          console.log(error)
        }
      } else {
        if (typeof sucess === 'function') {
          sucess()
          this.checktext = this.$t('game.userIdNotice')
        }
      }
    },
    // 登录成功
    checkidSuccessCallback(dat) {
      this.FETCH_GAME_SCHEME(this.gameid)
      //缓存当前id
      if (this.accept) {
        this.$utils.customLocalStorage.setItem('session', this.encode(dat.user_id))
      }
      this.$set(this.gameinfo, 'id', dat.user_id)
      this.$set(this.gameinfo, 'icon', dat.icon)
      this.$set(this.gameinfo, 'name', dat.nickname)
      this.$set(this.gameinfo, 'role_id', dat.role_id)
      this.$set(this.gameinfo, 'extra_info', dat.extra_info || { value: '' })
      this.$set(this.gameinfo, 'show_entry', dat.show_entry)
      this.$set(this.gameinfo, 'has_red_dot', dat.has_red_dot)
      this.$set(this.gameinfo, 'rank', dat.rank)
      this.$set(this.gameinfo, 'real_role_id', dat.real_role_id)
      this.tempRoleId = undefined

      this.SET_LOGIN(dat)
      if (dat.loginType) {
        this.SET_LOGIN_TYPE(dat.loginType)
      }

      // 如果是 session 登录，则把 session 的 token 存到 localstorage 里面，用于触发别的页签的登录状态刷新
      const sessionToken = this.$utils.customSessionStorage.getItem('vpses')
      this.$utils.customLocalStorage.setItem('ss_act', sessionToken || '')

      //通知头部导航栏
      this.$store.commit('SET_USERINFO', dat)

      this.player_whitelist_status = dat.player_whitelist_status

      this.$ta.setSuperProperties({
        fake_id: dat.role_id,
      })
      this.getRoleInfo({ data: dat })
      if (dat.extra_info && dat.extra_info.value) {
        this.$ta.setSuperProperties({
          server_id: (dat.extra_info && dat.extra_info.value) || '',
        })
      } else {
        this.$ta.unsetSuperProperty('server_id')
      }

      this.$ta.login(dat[process.env.VUE_APP_TA_ACCOUNT_KEY || 'role_id'])

      this.checktext = ''
      //
      this.editis = true

      // 关闭登陆弹窗
      this.apploginis = false

      //判断币种是否和当前一致
      if (dat.currency) {
        this.moneyUnit = dat.currency_label + ' '
        conutryarr.forEach((item) => {
          if (item.money === dat.currency) {
            this.$store.commit('app/SET_COUNTRY', item)
          }
        })
        this.list = []
        this.clearid()
        this.getPackageInfo(() => {
          this.packagereset()
        })
      }

      this.$rum.setShareProperties({
        userId: dat.role_id,
        gameid: this.gameid,
        fake_id: dat.role_id,
        real_role_id: dat.real_role_id,
      })
      this.$rum.setUserId(dat.user_uid)

      // 初始化弹屏活动（登录成功后触发）
      this.initPopupActivitiesAfterLogin()
    },
    /** 初始化弹屏活动 */
    async initPopupActivitiesAfterLogin() {
      if (!process.env.VUE_APP_POPUP_ACTIVITIES) return
      await initPopupActivities({
        popupQueue: this.popupQueue,
        store: this.$store,
        showPopup: (id, data) => {
          this.activeActivityPopup = { id, data }
        },
      })
    },
    /** 关闭活动弹窗，上报已读 */
    closeActivityPopup() {
      const popup = this.activeActivityPopup
      if (!popup) return
      this.activeActivityPopup = null
      this.popupQueue.resolve(popup.id)

      // 上报已读
      if (popup.id === 'bonus-reward' && popup.data && popup.data.events) {
        const eventIds = popup.data.events.map((e) => e.event_id)
        reportEventsRead(eventIds, this.$store)
      }
    },
    /** 打开任务宝箱后清除 Banner 红点动效 */
    clearRewardsRedDot() {
      this.$set(this.gameinfo, 'has_red_dot', 0)
    },
    async getPackageInfo(fn) {
      this.setShowLoading(true)
      this.packagedict = {}
      try {
        const context = {
          gameId: this.gameid,
          currency: this.conutry.money,
          locale: this.$i18n.locale,
          isMobile: this.isMobile,
          listId: this.list_id != '' && this.list_id + '' != 'undefined' ? this.list_id : '',
        }
        if (this.isLogin) {
          context.role_id = this.userInfo.role_id
          context.real_role_id = this.userInfo.real_role_id
        }
        await initGiftPlugins(context)
        const shopState =
          this.$store.state.gift.shop ||
          this.$store.state.gift['fat-custom'] ||
          this.$store.state.gift['fuzhou-custom']

        if (shopState && shopState.list) {
          this.list = shopState.list
          this.list_id = shopState.listId
          this.packagedict = shopState.packageDict
          this.activityBanner = shopState.activityBanner
          this.moneyUnit = shopState.moneyUnit
          this.gateway_package_ids = shopState.gatewayPackageIds
          this.adyenDecimalPrecision = shopState.adyenDecimalPrecision

          if (shopState.paypalClientId) {
            this.$store.commit('config/SET_PAYPAL_CLIENT_ID', shopState.paypalClientId)
          }

          this.$store.commit('SET_IS_FIRST', shopState.showBonus)
          this.setPaywats(shopState.supportGateways)
          if (this.packageid != '' && this.packagedict['package' + this.packageid]) {
            this.selpackage(this.packagedict['package' + this.packageid])
          }
          if (fn) {
            fn()
          }
          this.$root.Bus.$emit('gift-packages-refreshed')
        }
      } catch (err) {
        console.error('[Gift] getPackageInfo failed:', err)
      } finally {
        this.setShowLoading(false)
      }
    },
    getQueryString(name) {
      return this.$route.query[name] || null
    },

    findPackageByPackIndex(packIndex) {
      if (packIndex == null || packIndex === '') return null
      return (
        Object.values(this.packagedict).find(
          (item) => item && String(item.pack_index) === String(packIndex)
        ) || null
      )
    },

    payAgain() {
      this.maskstyle = ''
      if (this.isRuPsp) {
        const packIndex = this.$utils.customSessionStorage.getItem('psp_package_index')
        const pkg = this.findPackageByPackIndex(packIndex)
        if (pkg) {
          this.popupQueue.addBlocker('payment')
          this.selpackage(pkg, true)
        }
      } else if (this.paysty == 'paypay') {
        const packIndex = this.$utils.customSessionStorage.getItem('paypay_package_index')
        const pkg = this.findPackageByPackIndex(packIndex)
        if (pkg) {
          this.selpackage(pkg)
        }
      } else {
        const pkg = this.packagedict['package' + this.pack.id]
        if (pkg) {
          this.popupQueue.addBlocker('payment')
          this.selpackage(pkg)
        }
      }
      this.popupQueue.removeBlocker('payResult')
    },

    // 如果有用户 id 或 game_session 则尝试登录
    async doLogin() {
      let sessionData = {}
      if (this.game_session) {
        try {
          const response = await auth_login(
            {
              game_id: this.gameid,
              login_type: 'in_game',
              session_id: this.game_session,
            },
            true
          )
          if (response.data.code == 1) {
            sessionData = response.data.data
          } else {
            //失败上报失败原因
            this.$ta.track('vip_mall_combine', {
              operator_type: 4,
              code: response.data ? response.data.code : '',
              to_type: this.$enum.LOGIN_TYPE.in_game,
              index_id: this.$ta.getDistinctId(),
              ...(this.$store.state.app.fromInstalledWebApp
                ? { open_ui_old: 'desktop_shortcut' }
                : {}),
            })

            this.$rum.report(
              'login_operator_type',
              {
                operator_type: 4,
                to_type: this.$enum.LOGIN_TYPE.in_game,
                data: response.data,
              },
              4
            )
          }
        } catch (error) {
          this.$rum.report(error)
        }
      }

      // 没有 session 且没有 id 缓存，则不进行登录
      if (JSON.stringify(sessionData) === '{}' && !this.gameinfo.id) {
        this.$ta.track('vip_mall_view', {
          ...(this.$store.state.app.fromInstalledWebApp ? { open_ui_old: 'desktop_shortcut' } : {}),
        })
        return this.getPackageInfo()
      }

      // 没有 session，必有 id 缓存，尝试登录
      if (!this.game_session || JSON.stringify(sessionData) === '{}') {
        // 查看是否同意 cookie
        this.checkid('cacheLogin')
        return
      } else {
        // 有 session 且 session 可用，开始判断逻辑
        // 先查询 session 的用户列表
        try {
          const res = await checkfpid({ game_id: this.gameid }, sessionData.token)
          if (res.data.code == 1) {
            this.$store.commit('SET_IS_SHOW_PRODUCTION_TAX_TIPS', res.data.data.show_tax_notice)
            const fpidData = res.data.data

            // 如果是 session 登录，且有 role_id 和 package 信息
            // 认定为只拉收银台模式
            if (sessionData.role_id && sessionData.product_info) {
              this.$rum.report('only_pay_session_login', {
                sessionData,
                fpidData,
              })
              const userinfo = fpidData.user_data.find(
                (item) => item.role_id === sessionData.role_id
              )
              if (userinfo) {
                // 上次登录方式不是 role_id 且 fpid 一致，则直接登录 session 的账号
                this.$root.Bus.$emit('loginFromGame', {
                  authData: sessionData,
                  fpidData,
                  cacheLogin: false,
                })
                this.$ta.track('vip_mall_view', {
                  fake_id: userinfo.role_id,
                  to_type: this.$enum.LOGIN_TYPE.in_game,
                  ...(this.$store.state.app.fromInstalledWebApp
                    ? { open_ui_old: 'desktop_shortcut' }
                    : {}),
                })
                //获取账单信息
                this.$set(this, 'mail_data', fpidData.mail_data)
                this.SET_LOGIN_TYPE('in_game')
                this.loginCallback = () => {
                  const key = `only_pay_${sessionData.product_info.id}`
                  this.packagedict['package' + key] = {
                    ...sessionData.product_info,
                    isOnlyBuy: true,
                    real_id: sessionData.product_info.id,
                    id: key,
                  }
                  this.selpackage(this.packagedict['package' + key])
                }
              }
              return
            }

            // - 浏览器没有 Web Shop 登录缓存：展示选角弹窗，用户选择角色、勾选协议后登录（流程与授权登录一致，增加登录前需要勾选协议）
            // - 浏览器有 Web Shop 登录缓存：
            // - 授权登录或游戏跳转登录缓存，且缓存账号与游戏内为同一账号（FPID）：直接登录成功
            // - 授权登录或游戏跳转登录缓存，且缓存账号与游戏内账号（FPID）不一致：展示选角弹窗，用户选择角色、勾选协议后登录（流程与授权登录一致，增加登录前需要勾选协议）
            // - ID 登录缓存：展示选角弹窗，用户选择角色、勾选协议后登录（流程与授权登录一致，增加登录前需要勾选协议）

            // 0806增加逻辑 - 多页签 session 不互通，授权登录会打开新页签导致获取不到之前的 token，所以需要判断 token 是否存在，如果不存在直接拉起选角弹窗
            const token =
              this.$utils.customSessionStorage.getItem('vpses') ||
              this.$utils.customLocalStorage.getItem('vplocl')

            if (
              this.loginType !== 'role_id' &&
              this.loginType !== 'role_id_safe' &&
              this.fpid === sessionData.user_uid &&
              token
            ) {
              this.$rum.report(
                'in_game_login_directly',
                {
                  login_type: this.loginType,
                  old_fpid: this.fpid,
                  new_fpid: sessionData.user_uid,
                  old_token: (token || '').slice(-30),
                  new_token: (sessionData.token || '').slice(-30),
                },
                4
              )
              // 上次登录方式不是 role_id 且 fpid 一致，则直接登录 session 的账号
              this.$root.Bus.$emit('loginFromGame', {
                authData: sessionData,
                fpidData,
              })

              // 同 fpid 需要打点 vip_mall_view: b 场景
              const userinfo = fpidData.user_data.find(
                (item) => item.role_id === sessionData.role_id
              )
              this.$ta.track('vip_mall_view', {
                fake_id: userinfo.role_id,
                to_type: this.$enum.LOGIN_TYPE.in_game,
                ...(this.$store.state.app.fromInstalledWebApp
                  ? { open_ui_old: 'desktop_shortcut' }
                  : {}),
              })
              //获取账单信息
              this.$set(this, 'mail_data', fpidData.mail_data)
              this.SET_LOGIN_TYPE('in_game')
            } else {
              // 其他情况需要拉起选角弹窗，完成登录
              // 1. 干掉原有登录数据
              if (this.gameinfo.id) {
                this.logoutAndClearData(true)
              }
              this.getPackageInfo()
              // 打点 vip_mall_view: a 场景
              this.$ta.track('vip_mall_view', {
                ...(this.$store.state.app.fromInstalledWebApp
                  ? { open_ui_old: 'desktop_shortcut' }
                  : {}),
              })
              // 2. 拉起选角弹窗
              this.$root.Bus.$emit('showLoginFromGame', {
                authData: sessionData,
                fpidData,
                callback: () => {
                  //获取账单信息
                  this.$set(this, 'mail_data', fpidData.mail_data)
                  this.SET_LOGIN_TYPE('in_game')
                },
              })
            }
          } else {
            if (this.gameinfo.id) {
              this.checkid('cacheLogin')
              return
            } else {
              this.$ta.track('vip_mall_view', {
                ...(this.$store.state.app.fromInstalledWebApp
                  ? { open_ui_old: 'desktop_shortcut' }
                  : {}),
              })
              return this.getPackageInfo()
            }
          }
        } catch (error) {
          this.$rum.report(error)
        }
      }
    },

    updatePayinfo(data) {
      this.payinfo = {
        ...this.payinfo,
        ...data,
      }
    },

    setLastGateway(last_gateway) {
      //上一次支付的内容如果有就用上一次的
      if (last_gateway) {
        var cgpaysty = this.$utils.customSessionStorage.getItem('cgpsty')
        if (cgpaysty && cgpaysty != '') {
          this.$utils.customSessionStorage.removeItem('cgpsty')
        } else {
          cgpaysty = this.$enum.PAY_WAY_MAP[last_gateway]
            ? this.$enum.PAY_WAY_MAP[last_gateway]
            : ''
        }
        //this.paysty = cgpaysty
        this.last_gateway = cgpaysty
      }
    },

    setPaywats(support_gateways) {
      if (!support_gateways || support_gateways.length === 0) return
      const arr = []
      var nowDeviceType = this.$utils.getAppleDeviceType()
      console.log('support_gateways======', support_gateways)
      support_gateways.forEach((res) => {
        const payWay = this.$enum.PAY_WAY_MAP[res]
        // 默认将adyen移动到前面
        if (res == 75 || res == 83) {
          arr.unshift(payWay)
        } else if (res == 8301) {
          try {
            if (window.ApplePaySession) {
              var applepayis = ApplePaySession.canMakePayments()
              console.log('设备是否支持Apple Pay：' + applepayis)
              this.applepay_is = applepayis == true ? true : false
            } else {
              console.log('不支持 Apple Pay')
              this.applepay_is = false
            }

            if (this.applepay_is) {
              if (nowDeviceType == 'Other') {
                arr.push(payWay)
              } else {
                arr.unshift(payWay)
              }
            }
          } catch (err) {
            console.log(err)
          }
        } else {
          if (payWay) {
            arr.push(payWay)
          }
        }
      })

      console.log('this.paysty======', this.paysty)
      //3ds回显的时候会带着
      this.paysty =
        this.paysty !== null &&
        this.paysty !== undefined &&
        this.paysty !== '' &&
        arr.includes(this.paysty)
          ? this.paysty
          : arr[0]

      // FOR_RU 强制使用 RU_PSP
      if (
        this.is_RU_GAME &&
        (support_gateways.includes(this.$enum.GATEWAY_MAP.payermax) ||
          support_gateways.includes(this.$enum.GATEWAY_MAP.deepgrow))
      ) {
        this.isRuPsp = true
      }
    },

    goShopping() {
      console.log('判断用户首充======', this.$store.state.user.isFirst)
      // 如果用户是首充用户，支付成功后重新请求接口查询首充情况
      if (this.$store.state.user.isFirst) {
        this.clearid()
        this.getPackageInfo()
      }
      this.$root.Bus.$emit('paySuccess')
      this.maskstyle = ''
      this.popupQueue.removeBlocker('payResult')

      // 完成支付 或 关闭支付结果弹窗 清除 game_session
      this.game_session = ''
    },
    closePayConfirm() {
      this.showPayComponent = false
      this.cardpayis = false
      this.popupQueue.removeBlocker('payment')
    },

    // 取消发送发票
    sendInvoiceCancel() {
      this.isReceiptEmailEdit = true
      this.sendInvoiceErrorTips = ''
      this.$set(this.mail_data, 'mail', '')
      // this.selectEmail = ''
      this.$set(this.mail_data, 'mail_token', '')
      this.$nextTick(() => {
        const el = this.$refs.invoiceEmailInput
        if (el) el.focus()
      })
    },

    async preOpenInvoice() {
      this.$set(this.mail_data, 'mail', '')
      this.$set(this.mail_data, 'mail_token', '')
      this.setShowLoading(true)
      const obj = {
        game_id: this.gameid,
        web_mail_uid: this.webMailUid,
      }

      getInvoiceEmail(obj)
        .then((res) => {
          if (res?.data?.code === 1) {
            this.$set(this, 'mail_data', res?.data?.data)
            this.$set(this, 'cache_email', res?.data?.data)
          }
        })
        .catch(() => {})
        .finally(() => {
          this.$set(this.mail_data, 'mail', '')
          this.setShowLoading(false)
        })
    },

    // 关闭发票弹窗
    handleInvoiceClose() {
      if (this._emailListBlurTimer) clearTimeout(this._emailListBlurTimer)
      this.$set(this.mail_data, 'mail', '')
      this.isReceiptEmailEdit = true
      this.sendInvoiceErrorTips = ''
      this.showEmailList = false
    },

    // 点击输入框聚焦时展示邮箱列表
    onEmailInputFocus() {
      if (this._emailListBlurTimer) clearTimeout(this._emailListBlurTimer)
      this.showEmailList = true
    },

    // 手动输入新邮箱时收起列表，避免遮挡输入过程
    onEmailInputChange() {
      if (this._emailListBlurTimer) clearTimeout(this._emailListBlurTimer)
      this.showEmailList = false
      this.$set(this.mail_data, 'mail_token', '')
    },

    // 输入框失焦时延迟收起邮箱列表，避免点击列表项时先触发了 blur 导致列表消失
    onEmailInputBlur() {
      this._emailListBlurTimer = setTimeout(() => {
        this.showEmailList = false
      }, 300)
    },

    // 选择邮箱列表项，填入输入框
    onSelectInvoiceEmail(item) {
      // if (this._emailListBlurTimer) clearTimeout(this._emailListBlurTimer)
      const mail = item.mail || item
      const mailToken = item.mail_token != null ? item.mail_token : ''
      this.$set(this.mail_data, 'mail', mail)
      // this.selectEmail = mail;
      this.$set(this.mail_data, 'mail_token', mailToken)
      if (item.is_remember != null) this.$set(this.mail_data, 'is_remember', !!item.is_remember)
      if (item.is_send_information != null)
        this.$set(this.mail_data, 'is_send_information', !!item.is_send_information)
      this.isReceiptEmailEdit = false
      // this.showEmailList = false
    },

    // 删除邮箱列表项 - 二次确认：{email} 为动态邮箱，绿色高亮（需 contentHtml）
    onDeleteInvoiceEmail(index) {
      const row = this.mail_data.list && this.mail_data.list[index]
      const emailRaw =
        row == null ? '' : typeof row === 'string' ? row : row.mail || row.email || ''
      const emailEsc = String(emailRaw)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
      const emailHtml = `<span class="confirm-content-email">${emailEsc}</span>`
      this.$confirm({
        title: this.$t('game.delEmailTitle'),
        content: this.$t('game.delEmailContent', { email: emailHtml }),
        contentHtml: true,
        confirmText: this.$t('game.confirm'),
        cancelText: this.$t('game.orderCancel'),
        confirm: () => {
          this.deleteMailInfo(index)
        },
      })
    },

    async deleteMailInfo(index) {
      const obj = {
        mail_token: this.mail_data.list[index].mail_token,
        game_id: this.gameid,
      }
      const res = await deleteMailInfo(obj)
      if (res.data.code == 1) {
        const list = Array.isArray(this.mail_data.list) ? [...this.mail_data.list] : []
        list.splice(index, 1)
        this.$set(this.mail_data, 'list', list)
        if (this.cache_email && Array.isArray(this.cache_email.list)) {
          this.$set(this.cache_email, 'list', list)
        }
      }
    },

    // 第二次打开邮箱
    openInvoice() {
      this.invoiceis = true
      // 快速选中邮箱列表里的邮箱进行发送再次打开后不可编辑
      this.isReceiptEmailEdit = true
      const _cache_email = JSON.parse(JSON.stringify(this.cache_email || {}))
      this.$set(this, 'mail_data', _cache_email)
    },

    async getRoleInfo(obj) {
      try {
        const res = await checkfpid(
          {
            game_id: this.gameid,
            role_id: obj?.data?.role_id || '',
            channel_from: this.channel,
            tga_os: this.$ta.getPresetProperties().toEventPresetProperties()['#os'],
          },
          this.token
        )
        if (res.data.code != 1) return
        const role = res.data.data.user_data.find((item) => item.role_id === obj?.data?.role_id)
        if (!role) return
        this.$set(this.gameinfo, 'show_entry', role.show_entry)
        if (!this.$refs.gameTaskRewards?.taskRewardsVisible) {
          this.$set(this.gameinfo, 'has_red_dot', role.has_red_dot)
        }
      } catch (e) {
        console.error(e)
      }
    },
  },
}

/** wos / kingshot 奖励详情 GIF 预加载，避免首次打开详情弹窗白屏 */
</script>
<style lang="less" scoped>
/* 仅发票弹窗：让 email-list-wrap 浮在 Send 按钮之上，不影响其他 Dialog */
.invoice-dialog {
  ::v-deep(.dialog-body) {
    position: relative;
    overflow: visible;
    max-height: none;
    z-index: 2;
  }
  ::v-deep(.dialog-footer) {
    position: relative;
    z-index: 1;
  }
}

/* 邮箱选择列表：紧贴输入框下方的下拉，分隔线样式，可滚动 */
/* 邮箱下拉列表定位到输入框正下方 */
.email-list-wrap {
  position: absolute;
  border-radius: 8px;
  left: 0;
  right: 0;
  top: calc(100% + 6px);
  z-index: 10;
  background-color: #ffffff;
}

.email-list {
  max-height: 172px;
  border-radius: 8px;
  overflow-y: auto;
  background-color: #ffffff;
  border: 1px solid #e8eaed;
  // -webkit-overflow-scrolling: touch;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

  /* iOS：touch 滚动会单独开合成层，v-if 卸掉节点后常见空白「鬼影」，改回 auto 可消 */
  &.email-list--ios {
    -webkit-overflow-scrolling: auto;
  }

  .email-list-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    min-height: 50px;
    padding: 0 12px 0 16px;
    background: #fff;
    cursor: pointer;
    transition:
      background-color 0.15s,
      color 0.15s;
    &::after {
      content: '';
      position: absolute;
      left: 10px;
      right: 10px;
      bottom: 0;
      height: 1px;
      background: #e8eaed;
    }
    &:last-child {
      &::after {
        display: none;
      }
    }
    &:hover,
    &:active {
      // background: #f8f9fa;
      .email-list-item-text {
        color: #1bc263;
      }
    }
    .email-list-item-text {
      font-size: 14px;
      font-weight: 400;
      color: #343a3f;
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .email-list-item-delete {
      flex-shrink: 0;
      width: 16px;
      height: 16px;
      margin-left: 8px;
      display: block;
      object-fit: contain;
      cursor: pointer;
      border-radius: 4px;
      // &:hover {
      //   background: #eee;
      //   opacity: 0.9;
      // }
    }
  }
}

.send-content {
  padding: 0 16px;
  position: relative;
  .send-content-title {
    font-size: 14px;
    color: #62676b;
    text-align: center;
  }

  .email {
    position: relative;
    margin-bottom: 16px;
    input {
      margin-top: 24px;
      height: 44px;
      width: 100%;
      background-color: #ffffff;
      border: 1px solid #4d5358;
      font-size: 16px;
      font-weight: 400;
      padding: 0 32px 0 12px;
      outline: 0px;
      display: block;
      border-radius: 8px;
      &.error {
        border-color: #df3c3c;
      }
      &:disabled {
        background-color: #e9ecef;
      }
    }
    .error-tips {
      font-size: 14px;
      color: #df3c3c;
      margin-top: 4px;
    }

    .input-cancel {
      width: 20px;
      height: 20px;
      .bg-image('icon_input_cancel');
      position: absolute;
      top: 12px;
      right: 8px;
      cursor: pointer;
    }
  }

  .checkbox {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;

    .icon {
      width: 18px;
      height: 18px;
      margin-top: 1px;
      flex-shrink: 0;
      .bg-image('icon_checkbox');
      &.active {
        .bg-image('icon_checkbox_active');
      }
    }

    .agree-item {
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
      line-height: 1.4;
      font-size: 14px;
      color: #62676b;
      .icon {
        margin-right: 8px;
      }
      & + .agree-item {
        margin-top: 8px;
      }
    }
  }
}
</style>
